import { Audience, DataSource } from "../../../components/marketing/audience/type";

export const initialAudiences: Audience[] = [
  { id: '1', name: 'Active Users (45 Days)', size: 70100, status: 'ACTIVE', updated: '9/8/2025' },
  { id: '2', name: 'Funnel Drop-off', size: 8600, status: 'ACTIVE', updated: '9/8/2025' },
  { id: '3', name: 'High LTV Shoppers', size: 32450, status: 'ACTIVE', updated: '9/8/2025' },
  { id: '4', name: 'Churn Risk (30d)', size: 12780, status: 'ACTIVE', updated: '9/8/2025' },
  { id: '5', name: 'Cart Abandoners', size: 15420, status: 'ACTIVE', updated: '9/8/2025' },
  { id: '6', name: 'New Signups (7d)', size: 4820, status: 'ACTIVE', updated: '9/8/2025' },
  { id: '7', name: 'Repeat Buyers', size: 9150, status: 'ACTIVE', updated: '9/8/2025' },
  { id: '8', name: 'Viewed Product but No Purchase', size: 20340, status: 'ACTIVE', updated: '9/8/2025' },
  { id: '9', name: 'Email Engaged (90d)', size: 44210, status: 'ACTIVE', updated: '9/8/2025' },
  { id: '10', name: 'VIP Customers', size: 2150, status: 'ACTIVE', updated: '9/8/2025' },
];

export const dataSources: DataSource[] = [
  { name: 'Users', fields: 8 },
  { name: 'Events', fields: 5 },
  { name: 'Orders', fields: 5 },
];